import type { Permission } from '../types'

type Props = {
  label: string
  permissions: Permission[]
  selected: Set<string>
  onToggle: (code: string) => void
  disabled?: boolean
}

/**
 * Grupa checkboxów uprawnień jednej domeny (prefiks przed pierwszą kropką w kodzie PERM).
 * Nagłówek to polska etykieta domeny. Używana w RolePermissionsPanel.
 */
export function PermissionGroup({ label, permissions, selected, onToggle, disabled }: Props) {
  return (
    <fieldset className="flex flex-col gap-1">
      <legend className="mb-1 text-xs font-semibold uppercase tracking-wide text-slate-500">{label}</legend>
      {permissions.map(p => (
        <label
          key={p.code}
          className="flex cursor-pointer items-center gap-2 rounded border border-slate-200 bg-white px-2.5 py-1.5 text-sm hover:bg-slate-50 has-[:disabled]:cursor-not-allowed has-[:disabled]:opacity-60"
        >
          <input
            type="checkbox"
            checked={selected.has(p.code)}
            onChange={() => onToggle(p.code)}
            disabled={disabled}
            className="size-4 shrink-0 accent-sky-600"
          />
          <span className="flex-1 text-slate-900">{p.description ?? p.code}</span>
          <span className="shrink-0 font-mono text-[10px] text-slate-400">{p.code}</span>
        </label>
      ))}
    </fieldset>
  )
}
